import React from 'react';
import '../../styles/components/CharacterTag.css';

interface CharacterTagProps {
  name: string;
  onRemove: () => void;
}

/**
 * A removable tag displaying a character name
 */
const CharacterTag: React.FC<CharacterTagProps> = ({ name, onRemove }) => {
  return (
    <div className="character-tag">
      <span className="character-name">{name}</span>
      <button
        type="button"
        className="remove-character"
        onClick={onRemove}
        aria-label={`Remove ${name}`}
      >
        ×
      </button>
    </div>
  );
};

export default CharacterTag; 